import React from 'react'
import Billboard from './Billboard'
import initialLayout from './utility/initialLayout'

const Animal = ({ data }) => {
	if (data.length === 0) {
		return (
			<></>
		)
	} else {
		console.log('Log / set Billboard: ', data)

		const list = data.map((item, index) => {
			const layout = initialLayout(index, { x: item.x, y: item.y, z: item.z })

			return (
				<Billboard
					name={'URB/ZOO:' + item.name}
					key={item.id}
					position={layout.position}
					direction={layout.direction}
					image={item.image}
					frameNum={item.num}
					size={[item.scaleU, item.scaleV, 1]}
					isClockwise={item.isClockwise}
				/>
			)
		})

		return (
			<>
				{list}
			</>
		)
	}
}

export default Animal